export const DRAWER_WIDTH = 335